import AppModalContainer from '@nxsys/components/AppModalContainer';
import PSRListing from '../../revenueFilings/listing/PSR';
import SubmitPSR from '../../submitPSR';
import PSRErrorSubmission from './PSRErrorSubmission';

export enum PSRModalTypeEnum {
  SUBMIT_PSR = 'SUBMIT_PSR',
  PSR_ERROR_SUBMISSIONS = 'PSR_ERROR_SUBMISSIONS',
  PSR_HISTORY = 'PSR_HISTORY',
}

type Props = {
  isOpen: boolean;
  toggle: () => void;
  type: PSRModalTypeEnum;
  cbAfterAction?: () => void;
};

const PSRModal: React.FC<Props> = ({ isOpen, toggle, type, cbAfterAction = () => { } }) => {
  const renderContentByType = () => {
    switch (type) {
      case PSRModalTypeEnum.SUBMIT_PSR:
        return <SubmitPSR cbAfterAction={cbAfterAction} isDashboard />;
      case PSRModalTypeEnum.PSR_ERROR_SUBMISSIONS:
        return <PSRErrorSubmission cbAfterAction={cbAfterAction} isDashboard />;
      case PSRModalTypeEnum.PSR_HISTORY:
        return <PSRListing cbAfterAction={cbAfterAction} isDashboard />;
      default:
        return <></>;
    }
  };

  return (
    <AppModalContainer
      title={type === PSRModalTypeEnum.SUBMIT_PSR ? 'Submit PSR' : type === PSRModalTypeEnum.PSR_ERROR_SUBMISSIONS ? 'PSR Error Submissions' : 'PSR History'}
      isOpen={isOpen}
      toggle={toggle}
      className="max-sm:w-[100vw"
      width={1250}
      minHeight="0"
      noPaddingBody
      hiddenFooter
    >
      {renderContentByType()}
    </AppModalContainer>
  );
};

export default PSRModal;
